export default __webpack_public_path__ + "static/media/awaiting3.6a81cd64.svg";